export class ForgotPassword
{
  public Email: string;
  public MobileNo: string;
  public OTP: string;
  public Password: string;
  public CPassword: string;
  public RequestSource: string;
}
